/* Progressive enhancement: all product content is readable without JavaScript. */
(() => {
  const faq = document.querySelector('[data-yam-faq]');
  if (faq && !faq.dataset.initialized) {
    faq.dataset.initialized = 'true';
  const questions = [...faq.querySelectorAll('details')];
  faq.querySelectorAll('[data-faq-filter]').forEach(button => button.addEventListener('click', () => {
    faq.querySelectorAll('[data-faq-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    questions.forEach(question => {question.hidden = button.dataset.faqFilter !== 'all' && question.dataset.faqGroup !== button.dataset.faqFilter;});
  }));
  questions.forEach(question => question.addEventListener('toggle', () => {
    if (question.open) questions.forEach(other => {if (other !== question) other.open = false;});
  }));
  }
  const content = document.querySelector('[data-yam-content]');
  if (!content || content.dataset.initialized) return;
  content.dataset.initialized = 'true';
  // Merge Judge.me's same-identity Product fragment, preserving its real reviews.
  function mergeProductReviews() {
    const mainProduct = document.querySelector('[data-yam-pdp-pilot]');
    const reviewSchema = document.querySelector('script.jdgm-server-jld[type="application/ld+json"]');
    if (!mainProduct || !reviewSchema) return false;
    try {
      const reviews = JSON.parse(reviewSchema.textContent);
      for (const script of mainProduct.querySelectorAll('script[type="application/ld+json"]')) {
        const product = JSON.parse(script.textContent);
        if (product['@type'] !== 'Product' || reviews['@type'] !== 'Product' ||
            !product['@id'] || product['@id'] !== reviews['@id']) continue;
        if (reviews.aggregateRating) product.aggregateRating = reviews.aggregateRating;
        if (Array.isArray(reviews.review)) product.review = reviews.review;
        script.textContent = JSON.stringify(product);
        reviewSchema.remove();
        return true;
      }
    } catch (_) { /* Keep the original fragments when parsing fails. */ }
    return false;
  }
  if (!mergeProductReviews()) {
    const reviewBlock = document.querySelector('[id*="__judge_me_reviews_review_widget"]');
    if (reviewBlock) {
      // The app can append its schema asynchronously. Observe only its own block.
      const reviewObserver = new MutationObserver(() => {
        if (mergeProductReviews()) reviewObserver.disconnect();
      });
      reviewObserver.observe(reviewBlock, {childList: true, subtree: true});
      window.setTimeout(() => reviewObserver.disconnect(), 15000);
    }
  }
  const recommendation = document.querySelector('product-recommendations.related-products');
  if (recommendation) {
    // Shopify's deferred response can omit page-level product context.
    let productName = '';
    for (const script of document.querySelectorAll('script[type="application/ld+json"]')) {
      try {
        const data = JSON.parse(script.textContent);
        const products = Array.isArray(data) ? data : data['@graph'] || [data];
        const product = products.find(item => item['@type'] === 'Product' && item.name);
        if (product) { productName = product.name; break; }
      } catch (_) { /* Ignore unrelated invalid third-party structured data. */ }
    }
    const label = recommendation.dataset.yamRecommendationHeading ||
      (productName ? `Les clients ayant acheté ${productName} aiment aussi :` : '');
    if (label) {
      const headingObserver = new MutationObserver(setRecommendationHeading);
      function setRecommendationHeading() {
        const heading = recommendation.querySelector('.related-products__heading');
        if (heading) {
          heading.textContent = label;
          headingObserver.disconnect();
        }
      }
      headingObserver.observe(recommendation, {childList: true, subtree: true});
      setRecommendationHeading();
    }
  }
  const panels = [...content.querySelectorAll('[data-yam-panel]')];
  const nav = content.querySelector('.yam-information-nav');
  const links = [...nav.querySelectorAll('a')];
  const header = document.querySelector('.section-header');
  const shield = content.querySelector('.yam-nav-shield');
  let queued = false;
  function update() {
    queued = false;
    const marker = shield.getBoundingClientRect().bottom + 24;
    let active = panels[0];
    for (const panel of panels) {
      if (panel.getBoundingClientRect().top <= marker) active = panel;
      else break;
    }
    links.forEach(link => {
      if (link.hash === `#${active.id}`) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
  }
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
  const measure = () => {
    document.documentElement.style.setProperty('--yam-header-offset', `${Math.max(0, Math.ceil(header?.getBoundingClientRect().height || 0))}px`);
    content.style.setProperty('--yam-nav-height', `${Math.ceil(shield.getBoundingClientRect().height)}px`);
    schedule();
  };
  const resize = new ResizeObserver(measure);
  if (header) resize.observe(header);
  resize.observe(shield);
  window.addEventListener('scroll', schedule, {passive: true});
  window.addEventListener('resize', measure, {passive: true});
  const observer = new IntersectionObserver(schedule);
  panels.forEach(panel => observer.observe(panel));
  const mobile = window.matchMedia('(max-width: 749px)');
  const accordions = [...content.querySelectorAll('[data-yam-accordion]')];
  content.setAttribute('data-mobile-accordion-ready', '');
  function openPanel(panel) {
    accordions.forEach(accordion => { accordion.open = accordion.closest('[data-yam-panel]') === panel; });
  }
  function applyLayout() {
    if (mobile.matches) {
      const anchored = panels.find(panel => window.location.hash === '#' + panel.id);
      openPanel(anchored || panels[0]);
    } else accordions.forEach(accordion => { accordion.open = true; });
    measure();
  }
  accordions.forEach(accordion => accordion.querySelector('summary').addEventListener('click', event => {
    if (!mobile.matches) return;
    event.preventDefault();
    const opening = !accordion.open;
    accordions.forEach(other => { other.open = opening && other === accordion; });
    requestAnimationFrame(() => {
      const headingTop = accordion.getBoundingClientRect().top + window.scrollY;
      const headerHeight = Math.ceil(header?.getBoundingClientRect().height || 0);
      window.scrollTo({top: Math.max(0, headingTop - headerHeight - 12), behavior: 'instant'});
      schedule();
    });
  }));
  accordions.forEach(accordion => accordion.addEventListener('toggle', () => {
    if (mobile.matches && accordion.open) {
      accordions.forEach(other => { if (other !== accordion && other.open) other.open = false; });
    }
    schedule();
  }));
  mobile.addEventListener('change', applyLayout);
  window.addEventListener('hashchange', () => {
    const panel = panels.find(item => window.location.hash === '#' + item.id);
    if (mobile.matches && panel) {
      openPanel(panel);
      requestAnimationFrame(() => panel.scrollIntoView({block: 'start'}));
    }
  });
  applyLayout();
  document.querySelectorAll('[data-yam-pdp-pilot] a[href*="__lds_accordion_nhzw4n"]').forEach(link => { link.href = `#${panels[0].id}`; });
  content.addEventListener('click', event => {
    const button = event.target.closest('[data-dose]');
    if (!button) return;
    const nutrition = button.closest('[data-yam-nutrition]');
    if (!nutrition) return;
    const dose = button.dataset.dose;
    nutrition.querySelectorAll('[data-dose]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    nutrition.querySelectorAll('td[data-one]').forEach(cell => {cell.textContent = dose === 'unit' ? cell.dataset.one : cell.dataset.portion;});
    const heading = nutrition.querySelector('[data-dose-heading]');
    const caption = nutrition.querySelector('[data-dose-caption]');
    if (heading) heading.textContent = button.dataset.label;
    if (caption) caption.textContent = button.dataset.caption;
  });
})();
